import React, { createRef } from 'react';
import { CardBody } from 'reactstrap';

import RichText from '../../Common/RichText/RichText';
import ImageExpand from '../ImageExpand';
import RoundedButton from './RoundedButton';

class FlipAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.doFlip = this.doFlip.bind(this);
    this.state = {
      flipped: false,
      flipClass: 'flip-container mt-1 pt-5 pb-5 col-sm-10',
      cardHeight: '100px',
    };
    this.flipedCardRef = createRef();
  }

  // creates the links that appear in the left menu / Sidebar
  doFlip() {
    this.setState({ flipped: true });
    this.props.setClicked();
  }

  componentDidUpdate(prevProps, prevState) {
    const flipped = this.props.getClickedState();
    if (this.state.flipped !== flipped) {
      this.setState({
        flipped,
        flipClass: 'flip-container mt-1 pt-5 pb-5 col-sm-10',
        cardHeight: '100px',
      });
    }

    if (!prevState.flipped && this.state.flipped) {
      this.setState({
        flipClass:
          'flip-container d-flex justify-content-center show col-sm-11',
      });
      const card = this.flipedCardRef.current;
      if (card[0] && card !== 'undefined') {
        const answerHeight = card[0].clientHeight;
        if (answerHeight) {
          // making the card bigger taking into account the answer height
          this.setState({
            cardHeight: `${
              (answerHeight > 79 ? answerHeight + 36 : answerHeight) * 1.3
            }px`,
          });
        }
      }
    }
  }

  render() {
    return (
      <CardBody
        className="d-flex flex-column align-items-center flash-card pointer justify-content-center overflow-hidden"
        onClick={this.doFlip}
      >
        <div
          className={this.state.flipClass}
          style={{ minHeight: this.state.cardHeight }}
        >
          <div
            color="link"
            className="revealButton d-flex flex-column align-items-center justify-content-center front"
            style={{ height: '100%' }}
          >
            <RoundedButton iconClass="icon-eye" />
            <h5 className="mt-2">Click to reveal answer</h5>
          </div>
          {this.state.flipped && (
            <div
              className="flip-card-answer text-center back"
              ref={this.flipedCardRef}
            >
              <h5>Answer</h5>
              <RichText html={this.props.answer.text || ''} />
              <ImageExpand imageUrl={this.props.answer.imageUrl} />
            </div>
          )}
        </div>
      </CardBody>
    );
  }
}

export default FlipAnswer;
